import React from 'react';
import StatementMatch from '../../../../../activities/StatementMatch';

const activityContent = {
  type: 'statementMatch',
  intro1:
    'In this activity, practice turning “you” statements into “I” statements.',
  intro2:
    'Drag an “I” statement and drop it onto the matching “you” statement to reframe the message from an individual perspective.',
  columnHeaders: ['You', 'I'],
  columns: {
    1: {
      name: 'You are late.',
      key: 1,
      items: [],
    },
    2: {
      name: 'You are being rude & mean.',
      key: 2,
      items: [],
    },
    3: {
      name: 'You only think of yourself.',
      key: 3,
      items: [],
    },
    4: {
      name: 'You are always interrupting me.',
      key: 4,
      items: [],
    },
    5: {
      name: 'You always give in to the kids.',
      key: 5,
      items: [],
    },
    6: {
      name: 'You spend too much money when you take them out',
      key: 6,
      items: [],
    },
    7: {
      name: 'Answers',
      items: [
        {
          id: '4',
          content:
            'I wish we could do some of the things that are important to me too',
          key: 3,
        },
        {
          id: '2',
          content: 'I feel hurt when you talk to me like that.',
          key: 2,
        },
        {
          id: '3',
          content: "I worry about you when you don't get home on time.",
          key: 1,
        },
        {
          id: '5',
          content:
            "I'm concerned about what the kids learn when we don't follow through with what we say.",
          key: 5,
        },
        {
          id: '6',
          content:
            'I worry when we spend so much money on an afternoon with the children.',
          key: 6,
        },
        {
          id: '1',
          content:
            "I feel frustrated when I don't get to finish what I'm trying to say.",
          key: 4,
        },
      ],
    },
  },
};

const YouVsIStatementsActivity = () => {
  return (
    <div className='activity-wrap'>
      <div className='routine activity-wrapper'>
        <StatementMatch content={activityContent} />
      </div>
    </div>
  );
};

export default YouVsIStatementsActivity;
